import { render } from "./EditPlantJournalPosition.vue?vue&type=template&id=2c90d2df"
import script from "./EditPlantJournalPosition.vue?vue&type=script&lang=js"
export * from "./EditPlantJournalPosition.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__